import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C7596B",
      d: "m48 24.743-6.3-5.083 4.05-7.028-8.55-.747-.75-8.225-7.2 3.44L24.3.668l-4.65 6.579-7.5-3.888-.45 8.525-8.4.448 3.15 8.075L0 24.294l6.6 4.936-3.3 7.027 8.25.897.45 8.374 7.65-3.589 5.1 6.729 4.5-6.729 7.05 3.44.6-8.375 8.25-.15-3-6.879z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m14.344 31.09-2.961-8.46 2.233-.782 2.843 2.485a26 26 0 0 1 2.397 2.417l.037-.014c-.517-1.074-.955-2.203-1.398-3.47l-.865-2.473 1.756-.613 2.961 8.46-2.008.703-2.95-2.63a34 34 0 0 1-2.515-2.473l-.031.026a85 85 0 0 1 1.365 3.663l.892 2.548zm9.172-5.97c.34.769 1.248.872 2.142.56a5.7 5.7 0 0 0 1.605-.844l.703 1.204c-.538.471-1.261.866-2.09 1.157-2.083.729-3.697-.059-4.37-1.979-.543-1.555-.179-3.613 1.954-4.36 1.983-.695 3.278.586 3.809 2.104.114.326.178.629.202.776zm1.79-2.092c-.163-.465-.637-1.171-1.516-.864-.802.282-.874 1.122-.744 1.656zm3.324-3.826 1.366 2.339c.35.595.714 1.23 1.059 1.899l.026-.01a31 31 0 0 1-.251-2.165l-.231-2.751 1.507-.528 1.47 2.232c.405.633.81 1.267 1.182 1.924l.024-.009a34 34 0 0 1-.38-2.218l-.326-2.62 1.872-.656.264 6.796-1.794.629-1.334-1.958a24 24 0 0 1-1.056-1.771l-.026.009c.155.804.226 1.413.267 2.047l.139 2.375-1.794.628-3.928-5.515z"
    }, null, -1)
  ])))
}
export default { render: render }